import { registerToolboxCode } from "./utils";

registerToolboxCode("tspi", "spike");